import { OptionTemplate } from "shared/api/middleware-api-client/api";

// Remove trailing space + digits (e.g. "DeWaal 12" -> "De Waal")
export const removeTrailingNumber = (name: string) =>
  name.replace(/\s*\d+$/, "");

export function findMainVariant(
  layouts: OptionTemplate[],
  variantCodes: readonly string[],
  mainLayouts: readonly string[],
) {
  const variants = layouts.filter((layout) =>
    variantCodes.includes(layout.code),
  );

  if (variants.length === 0) return null;

  return (
    variants.find((layout) => mainLayouts.includes(layout.code)) || variants[0]
  );
}
